import "./GlobalFooterSocialMedia.scss";

import React from "react";

import { SvgIcon } from "../../models/app-data-model";
import { getContentHubDamAsset } from "../../utils/get-contenthub-dam-asset";

export type GlobalFooterSocialMediaProps = {
  svg_icon: SvgIcon;
  href?: string;
  alt_text: string;
};

const GlobalFooterSocialMedia: React.FC<GlobalFooterSocialMediaProps> = ({ svg_icon, href, alt_text }: GlobalFooterSocialMediaProps) => {

  const contenthubDamAsset = getContentHubDamAsset(svg_icon.contenthub_asset);

  return <li><a href={href} aria-label="{contenthubDamAsset?.alt_text}" target="_blank"><img src={contenthubDamAsset?.url} alt={contenthubDamAsset?.alt_text} width={svg_icon?.width} height={svg_icon?.height}/></a></li>

};

export default GlobalFooterSocialMedia;
